import { StandardEnum } from '@monkvision/types';

export function formatNumber(value: number, lang: string, fullDecimal: boolean): string {
  const thousandSeparator = lang.startsWith('en') ? ',' : ' ';
  const decimalSeparator = lang.startsWith('en') ? '.' : ',';

  const fixedValue = fullDecimal ? Math.round(value * 100) / 100 : value;
  const parts = fixedValue.toString().split('.');

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

  if (fullDecimal) {
    const decimalDigits = parts[1] || '00';
    const formattedDecimal = decimalDigits.padEnd(2, '0').slice(0, 2);
    return `${parts[0]}${decimalSeparator}${formattedDecimal}`;
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
}

export function formatPrice(price: number, currency: string, lang: string): string {
  const isLeftSideCurrency = ['$'].includes(currency);
  const left = isLeftSideCurrency ? currency : '';
  const right = !isLeftSideCurrency ? currency : '';
  return `${left}${formatNumber(price, lang, isLeftSideCurrency)}${right}`;
}

export function isValidEnumValue<T extends StandardEnum<string>>(
  value: string | number | null | undefined,
  enumValues: T,
): value is T[keyof T] {
  return (Object.values(enumValues) as (string | number | null | undefined)[]).includes(value);
}
